@if (tooltipData.content()) {
  <div
    class="bit-tooltip-container"
    [attr.data-position]="tooltipData.tooltipPosition()"
    [attr.data-visible]="tooltipData.isVisible()"
  >
    <div role="tooltip" class="bit-tooltip" [id]="tooltipData.id()">
      <ng-content>{{ tooltipData.content() }}</ng-content>
    </div>
  </div>
}
